import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
} from "@mui/material";
import ComplaintsTable from "./ComplaintesTableee";

const ComplaintSatus = ({ onRowClick }) => {
  const [selectedValue, setSelectedValue] = useState("Inprogress");
  const userName=localStorage.getItem('userName');
  const designation=localStorage.getItem('designation');

  const handleChange = (value) => {
    setSelectedValue(value);
  };

  const handleRowClick = (complaintId) => {
    onRowClick(complaintId);
  };

  return (
    <Card variant="outlined">
      <CardContent>
        <Box
          sx={{
            display: {
              sm: "flex",
              xs: "block",
            },
            alignItems: "flex-start",
          }}
        >
          <Box>
            <Typography
              variant="h3"
              sx={{
                marginBottom: "0",
              }}
              gutterBottom
            >
              {userName}'s Work-Orders
            </Typography>
          </Box>

          <Box
            sx={{
              marginLeft: "auto",
              mt: {
                lg: 0,
                xs: 2,
              },
              display: 'flex',
              gap: 2,
            }}
          >

            {(designation === 'Head of department') &&(
              <>
            <Button
              variant={selectedValue === "Inprogress" ? "contained" : "outlined"}
              color="primary"
              onClick={() => handleChange("Inprogress")}
            >
              Inprogress
            </Button>
            <Button
              variant={selectedValue === "Completed" ? "contained" : "outlined"}
              color="success"
              onClick={() => handleChange("Completed")}
            >
              Completed
            </Button>
            <Button
                variant={selectedValue === "Rejected" ? "contained" : "outlined"}
                color="error"
                onClick={() => handleChange("Rejected")}
              >
                Rejected
              </Button>
            {/* <Button
                variant={selectedValue === "UnderProcurement" ? "contained" : "outlined"}
                sx={{
                  backgroundColor: selectedValue === "UnderProcurement" ? "#FF9800" : "transparent",
                  color: selectedValue === "UnderProcurement" ? "#fff" : "#FF9800",
                  borderColor: selectedValue === "UnderProcurement" ? "#FF9800" : "rgba(0, 0, 0, 0.23)",
                  "&:hover": {
                    backgroundColor: selectedValue === "UnderProcurement" ? "#FB8C00" : "rgba(255, 152, 0, 0.08)",
                    borderColor: selectedValue === "UnderProcurement" ? "#FB8C00" : "rgba(0, 0, 0, 0.23)",
                  },
                }}
                onClick={() => handleChange("UnderProcurement")}
              >
                Under Procurement
              </Button> */}
            </>
            )}
            {(designation === 'Director' || designation === 'Complainer') && (
              <>
              <Button
                variant={selectedValue === "Inprogress" ? "contained" : "outlined"}
                color="primary"
                onClick={() => handleChange("Inprogress")}
              >
                Inprogress
              </Button>

              <Button
              variant={selectedValue === 'RequireJustification' ? "contained" : "outlined"}
              sx={{
                backgroundColor: selectedValue === 'RequireJustification' ? "#ffcc80" : "transparent",
                color: selectedValue === 'RequireJustification' ? "#fff" : "#ffcc80",
                borderColor: selectedValue === 'RequireJustification' ? "#ffcc80" : "rgba(0, 0, 0, 0.23)",
                "&:hover": {
                  backgroundColor: selectedValue === 'RequireJustification' ? "#ffa726" : "rgba(255, 204, 128, 0.08)",
                  borderColor: selectedValue === 'RequireJustification' ? "#ffa726" : "rgba(0, 0, 0, 0.23)",
                },
              }}
              onClick={() => handleChange("RequireJustification")}
            >
              Require Justification
            </Button>
            
              <Button
                variant={selectedValue === "Completed" ? "contained" : "outlined"}
                color="success"
                onClick={() => handleChange("Completed")}
              >
                Completed
              </Button>
              <Button
                variant={selectedValue === "Rejected" ? "contained" : "outlined"}
                color="error"
                onClick={() => handleChange("Rejected")}
              >
                Rejected
              </Button>
            {/* <Button
                variant={selectedValue === "UnderProcurement" ? "contained" : "outlined"}
                sx={{
                  backgroundColor: selectedValue === "UnderProcurement" ? "#FF9800" : "transparent",
                  color: selectedValue === "UnderProcurement" ? "#fff" : "#FF9800",
                  borderColor: selectedValue === "UnderProcurement" ? "#FF9800" : "rgba(0, 0, 0, 0.23)",
                  "&:hover": {
                    backgroundColor: selectedValue === "UnderProcurement" ? "#FB8C00" : "rgba(255, 152, 0, 0.08)",
                    borderColor: selectedValue === "UnderProcurement" ? "#FB8C00" : "rgba(0, 0, 0, 0.23)",
                  },
                }}
                onClick={() => handleChange("UnderProcurement")}
              >
                Under Procurement
              </Button> */}

              </>
            )}
            {(designation === 'AO Officer') && (
              <>
              <Button
                variant={selectedValue === "Inprogress" ? "contained" : "outlined"}
                color="primary"
                onClick={() => handleChange("Inprogress")}
              >
                Inprogress
              </Button>
            
              <Button
                variant={selectedValue === "Completed" ? "contained" : "outlined"}
                color="success"
                onClick={() => handleChange("Completed")}
              >
                Completed
              </Button>
              <Button
                variant={selectedValue === "Rejected" ? "contained" : "outlined"}
                color="error"
                onClick={() => handleChange("Rejected")}
              >
                Rejected
              </Button>

              </>
            )}
            {(designation === 'Supervisor') && (
              <>
              <Button
                variant={selectedValue === "Inprogress" ? "contained" : "outlined"}
                color="primary"
                onClick={() => handleChange("Inprogress")}
              >
                Inprogress
              </Button>
              <Button
                variant={selectedValue === "ToBeClosed" ? "contained" : "outlined"}
                sx={{
                  backgroundColor: selectedValue === "ToBeClosed" ? "#ffcc80" : "transparent",
                  color: selectedValue === "ToBeClosed" ? "#fff" : "#ffcc80",
                  borderColor: selectedValue === "ToBeClosed" ? "#ffcc80" : "rgba(0, 0, 0, 0.23)",
                  "&:hover": {
                    backgroundColor: selectedValue === "ToBeClosed" ? "#ffa726" : "rgba(255, 204, 128, 0.08)",
                    borderColor: selectedValue === "ToBeClosed" ? "#ffa726" : "rgba(0, 0, 0, 0.23)",
                  },
                }}
                onClick={() => handleChange("ToBeClosed")}
              >
                To Be Closed
              </Button>
              <Button
                variant={selectedValue === "Completed" ? "contained" : "outlined"}
                color="success"
                onClick={() => handleChange("Completed")}
              >
                Completed
              </Button>
              <Button
                variant={selectedValue === "UnderProcurement" ? "contained" : "outlined"}
                sx={{
                  backgroundColor: selectedValue === "UnderProcurement" ? "#FF9800" : "transparent",
                  color: selectedValue === "UnderProcurement" ? "#fff" : "#FF9800",
                  borderColor: selectedValue === "UnderProcurement" ? "#FF9800" : "rgba(0, 0, 0, 0.23)",
                  "&:hover": {
                    backgroundColor: selectedValue === "UnderProcurement" ? "#FB8C00" : "rgba(255, 152, 0, 0.08)",
                    borderColor: selectedValue === "UnderProcurement" ? "#FB8C00" : "rgba(0, 0, 0, 0.23)",
                  },
                }}
                onClick={() => handleChange("UnderProcurement")}
              >
                Under Procurement
              </Button>
              </>
            )}
            {(designation === 'Technician') && (
              <>
              <Button
                variant={selectedValue === "Inprogress" ? "contained" : "outlined"}
                color="primary"
                onClick={() => handleChange("Inprogress")}
              >
                Inprogress
              </Button>
              <Button
                variant={selectedValue === "ClosedByTechnician" ? "contained" : "outlined"}
                sx={{
                  backgroundColor: selectedValue === "ClosedByTechnician" ? "#ffcc80" : "transparent",
                  color: selectedValue === "ClosedByTechnician" ? "#fff" : "#ffcc80",
                  borderColor: selectedValue === "ClosedByTechnician" ? "#ffcc80" : "rgba(0, 0, 0, 0.23)",
                  "&:hover": {
                    backgroundColor: selectedValue === "ClosedByTechnician" ? "#ffa726" : "rgba(255, 204, 128, 0.08)",
                    borderColor: selectedValue === "ClosedByTechnician" ? "#ffa726" : "rgba(0, 0, 0, 0.23)",
                  },
                }}
                onClick={() => handleChange("ClosedByTechnician")}
              >
                Closed By Technician
              </Button>
              <Button
                variant={selectedValue === "Completed" ? "contained" : "outlined"}
                color="success"
                onClick={() => handleChange("Completed")}
              >
                Completed
              </Button>
              <Button
                variant={selectedValue === "UnderProcurement" ? "contained" : "outlined"}
                sx={{
                  backgroundColor: selectedValue === "UnderProcurement" ? "#FF9800" : "transparent",
                  color: selectedValue === "UnderProcurement" ? "#fff" : "#FF9800",
                  borderColor: selectedValue === "UnderProcurement" ? "#FF9800" : "rgba(0, 0, 0, 0.23)",
                  "&:hover": {
                    backgroundColor: selectedValue === "UnderProcurement" ? "#FB8C00" : "rgba(255, 152, 0, 0.08)",
                    borderColor: selectedValue === "UnderProcurement" ? "#FB8C00" : "rgba(0, 0, 0, 0.23)",
                  },
                }}
                onClick={() => handleChange("UnderProcurement")}
              >
                Under Procurement
              </Button>
              </>
            )}
          </Box>
        </Box>
        <Box
          sx={{
            
            maxHeight: "450px",
            overflow: "auto",
            mt: 3,
          }}
        >
          <ComplaintsTable selectedValue={selectedValue} onRowClick={handleRowClick} />

        </Box>
      </CardContent>
    </Card>
  );
};

export default ComplaintSatus;
